import IconArrowRight from "components/EvtKit/icons/IconArrowRight"
import { TabsContext } from "components/EvtKit/tabs/Tabs"
import Button from "components/EvtKit/button/Button"
import { ButtonWithConfirmation } from "components/ButtonWithConfirmation"

import { memo, useCallback, useContext } from "react"
import styled from "styled-components"
import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { tabIds } from "pages/products/constants/defaultValues"

const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  padding: 16px 0px 32px 0px;
`

interface NavigateButtonsProps {
  isValidProductForm: boolean
}

const NavigateButtons = (props: NavigateButtonsProps) => {
  const { isValidProductForm } = props

  const { onActiveTabIdChange } = useContext(TabsContext)

  const activateBenefitsTab = useCallback(() => {
    onActiveTabIdChange(tabIds.benefits)
  }, [onActiveTabIdChange])

  const navigate = useNavigate()

  const navigateToProductPage = useCallback(() => {
    navigate("/products")
  }, [])

  return (
    <ButtonContainer>
      <ButtonWithConfirmation
        label="Cancelar"
        className="fill-width secondary"
        actionWithConfirmation={navigateToProductPage}
        actionHeading="Cancelar"
        actionText="Você tem alterações não salvas que serão perdidas ao sair."
      />
      <Button
        className={clsx("fill-width", { disabled: !isValidProductForm })}
        disabled={!isValidProductForm}
        iconRight={<IconArrowRight />}
        label="Avançar etapa"
        onClick={activateBenefitsTab}
      />
    </ButtonContainer>
  )
}

export default memo(NavigateButtons)
